import React, { forwardRef } from 'react'
import PropTypes from 'prop-types'
import { makeStyles } from '@material-ui/core/styles'
import Popper from '@material-ui/core/Popper'
import { popperZIndex, popperSmallZIndex } from '../../common'

const useStylesLarge = props => makeStyles(theme => ({
  popper: {
    zIndex: popperZIndex,
    '&[x-placement*="top"]': {
      marginBottom: '23px',
    },
    '&[x-placement*="bottom"]': {
      marginTop: '23px',
    },
    '&[x-placement*="left"]': {
      marginRight: '23px',
    },
    '&[x-placement*="right"]': {
      marginLeft: '23px',
    },
    '&[x-placement*="top"] $largeArrow': {
      bottom: 0,
      left: 0,
      marginBottom: '-23px',
      borderLeft: '15px solid transparent',
      borderRight: '15px solid transparent',
      borderTop: `24px solid ${props.arrowBorderColor || 'black'}`,
    },
    '&[x-placement*="top"] $largeInnerArrow': {
      bottom: '1px',
      left: '0px',
      marginLeft: '-14px',
      borderLeft: '14px solid transparent',
      borderRight: '14px solid transparent',
      borderTop: `23px solid ${theme.palette.background.paper}`,
    },
    '&[x-placement*="bottom"] $largeArrow': {
      top: '1px',
      left: 0,
      marginTop: '-23px',
      borderLeft: '15px solid transparent',
      borderRight: '15px solid transparent',
      borderBottom: `23px solid ${props.arrowBorderColor || 'black'}`,
    },
    '&[x-placement*="bottom"] $largeInnerArrow': {
      top: '1px',
      marginLeft: '-14px',
      left: 0,
      borderLeft: '14px solid transparent',
      borderRight: '14px solid transparent',
      borderBottom: `22px solid ${theme.palette.background.paper}`,
    },
    '&[x-placement*="right"] $largeArrow': {
      top: 0,
      left: 0,
      marginLeft: '-22px',
      borderTop: '15px solid transparent',
      borderBottom: '15px solid transparent',
      borderRight: `23px solid ${props.arrowBorderColor || 'black'}`,
    },
    '&[x-placement*="right"] $largeInnerArrow': {
      top: '0px',
      left: '1px',
      marginTop: '-14px',
      borderTop: '14px solid transparent',
      borderBottom: '14px solid transparent',
      borderRight: `22px solid ${theme.palette.background.paper}`,
    },
    '&[x-placement*="left"] $largeArrow': {
      top: '0px',
      right: 0,
      marginRight: '-22px',
      borderTop: '15px solid transparent',
      borderBottom: '15px solid transparent',
      borderLeft: `23px solid ${props.arrowBorderColor || 'black'}`,
    },
    '&[x-placement*="left"] $largeInnerArrow': {
      top: '0px',
      right: '1px',
      marginTop: '-14px',
      borderTop: '14px solid transparent',
      borderBottom: '14px solid transparent',
      borderLeft: `22px solid ${theme.palette.background.paper}`,
    },
  },
  largeArrow: {
    zIndex: 20,
    position: 'absolute',
    width: 0,
    height: 0,
  },
  largeInnerArrow: {
    zIndex: 20,
    position: 'absolute',
    width: 0,
    height: 0,
  },
}))()

const useStylesSmall = props => makeStyles(theme => ({
  popper: {
    zIndex: popperSmallZIndex,
    '&[x-placement*="top"]': {
      marginBottom: '8px',
    },
    '&[x-placement*="bottom"]': {
      marginTop: '8px',
    },
    '&[x-placement*="left"]': {
      marginRight: '8px',
    },
    '&[x-placement*="right"]': {
      marginLeft: '8px',
    },
    '&[x-placement*="top"] $largeArrow': {
      bottom: 0,
      left: 0,
      marginBottom: '-8px',
      borderLeft: '6px solid transparent',
      borderRight: '6px solid transparent',
      borderTop: `9px solid ${props.arrowBorderColor || 'black'}`,
    },
    '&[x-placement*="top"] $largeInnerArrow': {
      bottom: '1px',
      left: '0px',
      marginLeft: '-5px',
      borderLeft: '5px solid transparent',
      borderRight: '5px solid transparent',
      borderTop: `8px solid ${theme.palette.background.paper}`,
    },
    '&[x-placement*="bottom"] $largeArrow': {
      top: '1px',
      left: 0,
      marginTop: '-8px',
      borderLeft: '6px solid transparent',
      borderRight: '6px solid transparent',
      borderBottom: `8px  solid ${props.arrowBorderColor || 'black'}`,
    },
    '&[x-placement*="bottom"] $largeInnerArrow': {
      top: '1px',
      marginLeft: '-5px',
      left: 0,
      borderLeft: '5px solid transparent',
      borderRight: '5px solid transparent',
      borderBottom: `7px solid ${theme.palette.background.paper}`,
    },
    '&[x-placement*="right"] $largeArrow': {
      top: 0,
      left: 0,
      marginLeft: '-7px',
      borderTop: '6px solid transparent',
      borderBottom: '6px solid transparent',
      borderRight: `8px solid ${props.arrowBorderColor || 'black'}`,
    },
    '&[x-placement*="right"] $largeInnerArrow': {
      top: '0px',
      left: '1px',
      marginTop: '-5px',
      borderTop: '5px solid transparent',
      borderBottom: '5px solid transparent',
      borderRight: `7px solid ${theme.palette.background.paper}`,
    },
    '&[x-placement*="left"] $largeArrow': {
      top: '0px',
      right: 0,
      marginRight: '-7px',
      borderTop: '6px solid transparent',
      borderBottom: '6px solid transparent',
      borderLeft: `8px solid ${props.arrowBorderColor || 'black'}`,
    },
    '&[x-placement*="left"] $largeInnerArrow': {
      top: '0px',
      right: '1px',
      marginTop: '-5px',
      borderTop: '5px solid transparent',
      borderBottom: '5px solid transparent',
      borderLeft: `7px solid ${theme.palette.background.paper}`,
    },
  },
  largeArrow: {
    zIndex: 20,
    position: 'absolute',
    width: 0,
    height: 0,
  },
  largeInnerArrow: {
    zIndex: 20,
    position: 'absolute',
    width: 0,
    height: 0,
  },
}))()


const PopperArrow = forwardRef((props, ref) => {
  return (
    <span ref={ref} className={props.classes.largeArrow}>
      <span className={props.classes.largeInnerArrow}/>
    </span>
  )
})

PopperArrow.propTypes = {  
  classes: PropTypes.object,
}

const BasePopper = props => {
  const [arrowRef, setArrowRef] = React.useState(null)
  const classesLarge = useStylesLarge(props)
  const classesSmall = useStylesSmall(props)
  return (
    <Popper
      id={props.id || 'basePopper'}
      open={props.open}
      anchorEl={props.anchorEl}
      placement={props.placement}
      disablePortal={props.disablePortal}
      className={props.size === 'small' ? classesSmall.popper : classesLarge.popper}
      modifiers={{
        flip: {
          enabled: props.flip === false ? props.flip : true,
        },
        arrow: {
          enabled: props.arrow === false ? props.arrow : true,
          element: arrowRef,
        },
        preventOverflow: {
          enabled: props.preventOverflow !== 'disabled',
          boundariesElement: props.preventOverflow,
        },
      }}
    >
      {props.arrow && props.anchorEl && <PopperArrow ref={setArrowRef} classes={props.size === 'small' ? classesSmall : classesLarge} />}
      {props.popperBody}
    </Popper>
  )
}

BasePopper.propTypes = {  
  anchorEl: PropTypes.object,
  placement: PropTypes.string.isRequired,
  disablePortal: PropTypes.bool,
  flip: PropTypes.bool,
  preventOverflow: PropTypes.string,
  popperBody: PropTypes.element,
  id: PropTypes.string,
  open: PropTypes.bool,
  arrow: PropTypes.bool,
  size: PropTypes.oneOf(['small', 'large']),
  // eslint-disable-next-line react/no-unused-prop-types
  arrowBorderColor: PropTypes.string,
}

BasePopper.defaultProps = {
  size: 'large',
  flip: true,
  arrow: true,
  disablePortal: false

}

export default BasePopper